$(function () {
    $('#key-info-collapse').on('hide.bs.collapse', function () {
        $(this).siblings('button[href="#' + $(this).prop('id') + '"]').html('<i class="' + FontAwesome.prefix('regular', 'eye') + '"></i> See More');
    });
    $('#key-info-collapse').on('show.bs.collapse', function () {
        $(this).siblings('button[href="#' + $(this).prop('id') + '"]').html('<i class="' + FontAwesome.prefix('regular', 'eye') + '"></i> See Less');
    });

    // Add actions to dismiss buttons
    const dismissNotificationUrl = base_url + 'home/ajax_dismiss';
    $('.notification .close').on('click', function () {
        var notificationId = $(this).parents('.alert').data('id');

        if (notificationId > 0) {
            $.ajax({
                url: dismissNotificationUrl + '/' + notificationId,
                method: 'GET',
                success: () => $(this).closest('.alert').remove(),
                error: function (xhr) {
                    Alert.error(
                        'Dismissing the notification failed: ' + xhr.responseText
                    );
                },
            });
        }
    });

    const homePageModuleVisible = $('#weekly-resource-module').length > 0;
    const onWeeklyResourcePage = $('#weekly-resource-container').length > 0;

    // Set the start month of the UoA calendar
    const weekOneMonth       = 8; // August
    const weekStart          = 1; // Monday
    const numDaysToDisplay   = 5;
    const checkedIconClass   = FontAwesome.prefix('regular', 'square-check');
    const uncheckedIconClass = FontAwesome.prefix('regular', 'square');
    const fridayIndex        = 5;

    // Get the baseUrl
    const baseUrl = $('#weeklyresourceslink').attr('href');

    let currentDate;
    let currentDayOfWeek;
    let nextYear;
    let startOfYear;
    let endOfYear;

    // Initialise event listener for show/hide resources links
    $('body').on('click', 'a[id^="section"][id$="-number-link"]', toggleResourceVisibility);

    if (homePageModuleVisible || onWeeklyResourcePage) {
        var studentProgrammeYear;
        // If user is a student, set their programme year
        if ($('#weekly-resource-container').length > 0) {
            studentProgrammeYear = weeklyResourceProgrammeYear;
        } else {
            const parsedValue = parseInt($('input[name="studentprogrammeyear"]').val());
            studentProgrammeYear = isNaN(parsedValue) ? null : parsedValue;
        }

        var programmeYear = 1;
        var startDate;
        var endDate;
        var weekNumber;

        // Get the current date
        currentDate      = dayjs();
        currentDayOfWeek = currentDate.day();
        nextYear         = currentDate.clone().add(1, 'year');
        startOfYear      = getWeekOneDate(currentDate, weekOneMonth);
        endOfYear        = getWeekOneDate(nextYear, weekOneMonth).subtract(1, 'week').endOf('week');

        // Calculate the number of days until the next Friday 5 pm
        const isAfterFriday =
            currentDayOfWeek > fridayIndex ||
            currentDayOfWeek === fridayIndex && currentDate.hour() >= 17;

        const daysUntilFriday = isAfterFriday
            ? fridayIndex + 7 - currentDayOfWeek
            : fridayIndex - currentDayOfWeek;

        // Calculate the end of next week
        const endOfNextWeek = currentDate.add(daysUntilFriday + 7, 'day').hour(17);

        // Get the maximum date for students to view in the datetimepicker
        var maxDate = currentDate.isBefore(endOfNextWeek)
            ? endOfNextWeek
            : endOfNextWeek.add(7, 'day');

        // Ensure the max date doesn't exceed the end of year
        maxDate = maxDate.isAfter(endOfYear) ? endOfYear : maxDate;

        const formattedEndOfYear   = endOfYear.format('YYYY-MM-DD');
        const formattedStartOfYear = startOfYear.format('YYYY-MM-DD');
        const formattedMaxDate     = studentProgrammeYear === null ? formattedEndOfYear : maxDate.format('YYYY-MM-DD');

        initialiseDates();
        updateNextButtonState();
        initialiseEventListeners();

        // Initialise datetimepicker
        $('#weekdatepicker, #resourcedatepicker').datetimepicker({
            dayOfWeekStart: 1,
            defaultSelect: true,
            format: 'Y/m/d',
            timepicker: false,
            todayButton: true,
            onGenerate: function () {
                $(this).find('.xdsoft_date.xdsoft_weekend').addClass('xdsoft_disabled');
            },
            onChangeDateTime: function (date) {
                const $picker = $(this);
                const lastSelectedDate = $picker.data('lastSelectedDate');

                // Check if the date has actually changed
                if (!lastSelectedDate || lastSelectedDate.getTime() !== date.getTime()) {
                    $picker.data('lastSelectedDate', date);
                    changeDateFromPicker(date);
                }
            },
            onShow: function () {
                this.setOptions({
                    minDate: formattedStartOfYear,
                    maxDate: formattedMaxDate,
                });

                const $picker = $(this);
                if (!$picker.data('lastSelectedDate')) {
                    const pickerVal = $picker.val();
                    const initialDate = pickerVal ? new Date(pickerVal) : new Date();
                    $picker.data('lastSelectedDate', initialDate);
                }
            },
        });
    }

    /**
     * Initialise the start and end dates for the week, load the header and content of weekly resource panel
     *
     * @return void
     */
    function initialiseDates() {
        programmeYear = studentProgrammeYear === null ? programmeYear : studentProgrammeYear;
        startDate = dayjs().startOf('week').add(1, 'day').startOf('day');
        endDate = dayjs(startDate).add(numDaysToDisplay - 1, 'day').endOf('day');
        renderWeeklyResourceHeader(true);
        if (homePageModuleVisible) {
            var adminAcademicYear = $('#admin-academic-year').val();

            if (adminAcademicYear === '') {
                renderWeeklyResourceContent(programmeYear, weekNumber);
                updateRedirectUrl(programmeYear, weekNumber);
            } else {
                renderWeeklyResourceContent(adminAcademicYear, weekNumber);
                updateRedirectUrl(adminAcademicYear, weekNumber);
            }
        }
    }

    var selectedYear;

    /**
     * Initialise event listeners for the navigation buttons, year select dropdown and 'this week' button
     *
     * @return void
     */
    function initialiseEventListeners() {
        $('.calendar-icon').on('click', () => $('#weekdatepicker, #resourcedatepicker').datetimepicker('show'));
        $('#this-week-button').on('click', () => moveToThisWeek());
        $('#weekly-previous-button').on('click', () => moveDays(-7));
        $('#weekly-next-button').on('click', () => moveDays(7));
        $('#weeklyyearselect').on('change', function () {
            renderWeeklyResourceHeader();
            renderWeeklyResourceContent(selectedYear, weekNumber);
            updateRedirectUrl(selectedYear, weekNumber);
        });
        $('body').on('click', '.saveCompletedResource', saveResourceCompletion);
        $('body').on('keydown', '.saveCompletedResource', function (event) {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                $(this).click();
            }
        });
    }

    /**
     * Change the date from the date picker to the start of the same week and move focus to that week
     *
     * @param  string dateString
     * @return void
     */
    function changeDateFromPicker(dateString) {
        if (dateString && dayjs(dateString).isValid()) {
            var newDate = dayjs(dateString).startOf('week');

            // Is the start date the same as weekly start?
            var currentDay = newDate.day();
            if (currentDay !== weekStart) {
                newDate = dayjs(newDate).day(weekStart - currentDay);
            }

            // Move to the new dates
            moveDays(newDate.diff(startDate, 'day'));
        }
    }

    /**
     * Return the UOA week number for a given start date
     *
     * @param  integer startDate
     * @return integer
     */
    function getUoaWeek(startDate) {
        let weekOneStart = getWeekOneDate(startDate, weekOneMonth);
        let weekNumber   = Math.abs(weekOneStart.diff(startDate, 'week')) + 1;

        return weekNumber;
    }

    /**
     * Return the start date of week one for a given month, based on the calendar start date
     *
     * @param  string  calendarStart
     * @param  integer month
     * @return dayjs
     */
    function getWeekOneDate(calendarStart, month) {
        const year        = calendarStart.format('YYYY');
        const paddedMonth = month < 10 ? '0' + month : month; // Add leading 0

        var weekOneStart = getWeekOneStart(year, paddedMonth);

        // Use the previous year if Week 1 starts after the calendar date
        if (weekOneStart.isAfter(calendarStart)) {
            weekOneStart = getWeekOneStart(year - 1, paddedMonth);
        }

        return weekOneStart;
    }

    /**
     * Calculate the start date of week one for a given year
     *
     * @param  integer year
     * @param  string  paddedMonth
     * @return dayjs
     */
    function getWeekOneStart(year, paddedMonth) {
        // Academic calendar override: Week 1 for 2026/27 starts 27 July 2026.
        // This differs from the historical rule where a Saturday 1 August
        // Resulted in the following Monday being Week 1 (e.g. 2015).
        const academicWeekOneOverrides = {
            2026: '2026-07-27',
        };

        if (Object.hasOwn(academicWeekOneOverrides, year)) {
            return dayjs(academicWeekOneOverrides[year]);
        }

        const firstOfMonth = dayjs(year + '-' + paddedMonth + '-01');

        var weekOneStart = firstOfMonth.clone().day(1); // Monday

        // If the 1st lands on a weekend
        if (firstOfMonth.weekday() >= 6) {
            weekOneStart = weekOneStart.add(1, 'week');
        }

        return weekOneStart;
    }

    /**
     * Render the header for the weekly resources
     *
     * @return void
     */
    function renderWeeklyResourceHeader(useAdminAcademicYear = false) {
        let headerText;
        if (dayjs(startDate).isSame(dayjs(endDate), 'month')) {
            headerText = dayjs(startDate).format('Do') + '-' + dayjs(endDate).format('Do MMMM YYYY');
        } else if (dayjs(startDate).isSame(dayjs(endDate), 'year')) {
            headerText = dayjs(startDate).format('Do MMMM') + ' - ' + dayjs(endDate).format('Do MMMM YYYY');
        } else {
            headerText = dayjs(startDate).format('Do MMMM YYYY') + ' - ' + dayjs(endDate).format('Do MMMM YYYY');
        }

        var adminAcademicYear = $('#admin-academic-year').val();

        if (useAdminAcademicYear === true && adminAcademicYear !== '') {
            $('#weeklyyearselect').val(adminAcademicYear);
        }

        weekNumber = getUoaWeek(startDate);
        selectedYear = $('#weeklyyearselect').val() || programmeYear;
        headerText = 'UoA Week - ' + weekNumber + ' ' + headerText;

        $('.panel-title').text('Year ' + selectedYear + ' Weekly Resources');
        $('.panel-subtitle').text(headerText);
    }

    /**
     * Render the weekly sections and resources
     *
     * @param  integer programmeYear
     * @param  integer weekNumber
     * @return void
     */
    function renderWeeklyResourceContent(programmeYear, weekNumber) {
        $.ajax({
            url: 'weeklyresources/ajax_weeklySectionResources',
            method: 'GET',
            data: {
                programmeyear: programmeYear,
                uoaWeek: weekNumber,
            },
            beforeSend: function () {
                $('.panel-section-loader').show().html('<i class="' + FontAwesome.prefix('solid', 'spinner', true) + '"></i> Loading Year ' + programmeYear + ' Content...');
            },
            success: function (response) {
                $('.panel-section').empty();
                let sectionContent = '';
                if (countVisibleSections(response.weeklySectionResources) > 0) {
                    $.each(response.weeklySectionResources, function (sectionIndex, section) {
                        if (parseInt(section.visible) === 1) {
                            sectionContent += '<h4>' + section.name + '</h4>';
                            if (section.summary !== null && section.summary.trim() !== '') {
                                sectionContent += '<div class="alert alert-info" role="alert">';
                                sectionContent += '<div class="summary">' + section.summary + '</div>';
                                sectionContent += '<button class="show-more-button">Show More</button>';
                                sectionContent += '</div>';
                            }

                            let visibleResources = [];
                            if (Array.isArray(section.resources)) {
                                visibleResources = getUniqueResources(section.resources);
                            }

                            if (Array.isArray(visibleResources) && visibleResources.length > 0) {
                                let resourceCount = visibleResources.length;
                                sectionContent += '<ul id="section' + sectionIndex + '" class="padded-list myList">';
                                $.each(visibleResources, function (resourceIndex, resource) {
                                    let iconClass = '';
                                    let returnFileType;
                                    let resourceType = resource.type;
                                    let iconInfo;
                                    switch (resource.type) {
                                        case 'file':
                                            returnFileType = true;
                                            iconInfo = File.getIcon(resource.uri.split('.', 2)[1], returnFileType);
                                            iconClass = iconInfo[0];
                                            resourceType = iconInfo[1];
                                            break;
                                        case 'guide':
                                            iconClass = FontAwesome.prefix('solid', 'book');
                                            break;
                                        case 'recording':
                                            iconClass = FontAwesome.prefix('solid', 'video-camera');
                                            break;
                                        case 'video':
                                            iconClass = FontAwesome.prefix('solid', 'film');
                                            break;
                                        case 'choice':
                                            iconClass = FontAwesome.prefix('solid', 'thumbs-up');
                                            break;
                                        case 'link':
                                            iconClass = FontAwesome.prefix('solid', 'link');
                                            break;
                                        case 'internal-link':
                                            iconClass = FontAwesome.prefix('solid', 'folder-tree');
                                            break;
                                        case 'elf':
                                            iconClass = FontAwesome.prefix('solid', 'table-list');
                                            break;
                                        case 'quiz':
                                            iconClass = FontAwesome.prefix('solid', 'question');
                                            break;
                                        default:
                                            iconClass = '';
                                            break;
                                    }
                                    let hideResourceClass  = resourceIndex >= numResourcesToDisplay && resourceCount > numResourcesToDisplay + 1 ? 'hide-resource' : '';
                                    let completedByStudent = parseInt(resource.completed) === 1 ? 'Completed: ' : 'Not Completed: ';
                                    let checkIcon          = parseInt(resource.completed) === 1 ? checkedIconClass : uncheckedIconClass;

                                    sectionContent += '<li class="no-border-bottom weekly-resources resource-item ' + hideResourceClass + '">';
                                    sectionContent += '<a href="' + base_url + 'pages/resource/' + resource.resources_id + '" target="_blank" role="presentation" aria-label="' + resource.name + ', ' + resource.type + '">';
                                    sectionContent += '<span class="fa-stack">';
                                    sectionContent += '<i class="' + FontAwesome.prefix('solid', 'circle') + ' ' + resourceType + '-resource-circle fa-stack-2x"></i>';
                                    sectionContent += '<i class="' + iconClass + ' fa-stack-1x ' + resourceType + '-resource-icon"></i>';
                                    sectionContent += '</span>';
                                    sectionContent += resource.name + '</a> ';
                                    sectionContent += '<div class="weekly-resource-links-container">';
                                    sectionContent += '<span>';
                                    sectionContent += '<a href="' + base_url + 'resources/find-in-curriculum-resources/' + programmeYear + '/' + resource.resources_id + '" target="_blank" aria-label="Find this resource in curriculum resources">';
                                    sectionContent += '<i class="' + FontAwesome.prefix('solid', 'folder-tree') + ' find-in-curriculum-icon" title="Find in Curriculum Resources" aria-hidden="true"></i>';
                                    sectionContent += '</a>';
                                    sectionContent += '</span>';

                                    if (response.basicrole === 'basic') {
                                        sectionContent += '<span class="fa-stack">';
                                        sectionContent += '<i tabindex="0" class="' + checkIcon + ' fa-stack-1x fa-xl saveCompletedResource" title="' + completedByStudent + resource.name + '" data-checked="' + resource.completed + '" data-resource-id="' + resource.resources_id + '"></i>';
                                        sectionContent += '</span>';
                                    }

                                    sectionContent += '</div>';
                                    sectionContent += '</li>';
                                });

                                // Calculate the number of hidden resources
                                let numHiddenResources = section.resources.length - numResourcesToDisplay;
                                let showMore = numHiddenResources > 1;
                                let buttonText = showMore ? 'Show ' + numHiddenResources + ' More' : 'Show Less';

                                sectionContent += '</ul>';
                                let hideMoreButtonClass = section.resources.length <= numResourcesToDisplay ? 'hide-resource' : '';
                                if (showMore) {
                                    sectionContent += '<a href="#" id="section' + sectionIndex + '-number-link" class="showmore-link ' + hideMoreButtonClass + '"><i class="' + FontAwesome.prefix('solid', 'arrow-turn-up') + ' fa-rotate-90"></i>' + buttonText + '</a>';
                                }
                            } else {
                                sectionContent += '<p class="no-resource-message">No resources available.</p>';
                            }
                        }
                    });
                } else {
                    sectionContent += '<p>No weekly content available. Please contact your year admin.</p>';
                }
                $('.panel-section').append(sectionContent);

                // Ensure 'Show More' button appears only when necessary
                $('.summary').each(function () {
                    const $summary = $(this);
                    const $button  = $summary.siblings('.show-more-button');

                    // Remove empty tags like <p></p> or elements with no visible content
                    $summary.find(':empty').remove();

                    // Add a utility class to the <p> tags
                    $summary.find('p').addClass('margin-bottom-0');

                    // Add max-height-4.5 class
                    $summary.addClass('max-height-4.5');

                    // Get the full content height including overflow and the visible height
                    const contentHeight   = $summary.get(0).scrollHeight;
                    const containerHeight = $summary.height();

                    // Check if content has any visible text or if there's valid HTML content
                    const textLength = $summary.text().trim().length;
                    const hasContent = $summary.html().trim().length > 0;

                    // Set a threshold for when to show the button
                    const threshold = 20;
                    if (contentHeight > containerHeight + threshold && textLength > 50 && hasContent) {
                        $button.show();
                    } else {
                        $button.hide();
                    }
                });

                $('.show-more-button').on('click', function () {
                    const $summary   = $(this).siblings('.summary');
                    const isExpanded = $summary.toggleClass('max-height-0').hasClass('max-height-0');
                    $(this).text(isExpanded ? 'Show Less' : 'Show More');
                });
            },
            complete: function () {
                $('.panel-section-loader').hide();
            },
            error: function (xhr, status, error) {
                console.error(xhr.responseText);
            },
        });
    }

    /**
     * Return a count of how many of the sections passed in are visible
     *
     * @return void
     */
    function countVisibleSections(sections) {
        let countOfVisibleSections = 0;
        for (let i = 0; i < sections.length; i++) {
            if (parseInt(sections[i].visible) === 1) {
                countOfVisibleSections++;
            }
        }

        return countOfVisibleSections;
    }

    /**
     * Filter the given array of resources to return only the unique and visible ones
     *
     * @param   array resources
     * @returns array
     */
    function getUniqueResources(resources) {
        const uniqueResources = [];
        const resourceIds     = [];

        for (const resource of resources) {
            // Check if the resource is visible and not already in the array
            if (isResourceVisible(resource) && !resourceIds.includes(resource.id)) {
                uniqueResources.push(resource);
                resourceIds.push(resource.id);
            }
        }

        return uniqueResources;
    }

    /**
     * Determine if a resource is visible based on its restriction status, time availability and section visibility
     *
     * @param  object resource
     * @return boolean
     */
    function isResourceVisible(resource) {
        const availableFrom = resource.availablefrom;
        const availableTo   = resource.availableto;
        const currentTime   = Math.floor(Date.now() / 1000);

        // Check if the resource is available and not restricted
        const isUnrestricted = parseInt(resource.restricted) !== 1;
        const isTimeValid    = currentTime >= availableFrom && (availableTo === null || currentTime < availableTo);

        // Check if the resource is within a visible section and parent section
        const isSectionVisible       = resource.page_section_visible === undefined || parseInt(resource.page_section_visible) === 1;
        const isParentSectionVisible = resource.parent_page_section_visible === undefined || parseInt(resource.parent_page_section_visible) === 1;

        return (isUnrestricted || isTimeValid) && isSectionVisible && isParentSectionVisible;
    }

    /**
     * Move the date range to this week and re-render the weekly resource panel
     *
     * @return void
     */
    function moveToThisWeek() {
        startDate = dayjs().startOf('week').add(1, 'day').startOf('day');
        endDate   = dayjs(startDate).add(numDaysToDisplay - 1, 'day').endOf('day');

        selectedYear = $('#weeklyyearselect').val() || programmeYear;

        renderWeeklyResourceHeader();
        if (homePageModuleVisible) {
            renderWeeklyResourceContent(selectedYear, weekNumber);
        }
        updateRedirectUrl(selectedYear, weekNumber);

        $('#weekly-next-button').prop('disabled', false);
        $('.alert-warning').hide();
    }

    /**
     * Move the date range by a specified amount of days and re-render the weekly resource panel
     *
     * @param  integer numDaysToMove
     * @return void
     */
    function moveDays(numDaysToMove) {
        startDate  = dayjs(startDate).add(numDaysToMove, 'day');
        endDate    = dayjs(endDate).add(numDaysToMove, 'day');
        weekNumber = getUoaWeek(startDate);

        selectedYear             = $('#weeklyyearselect').val() || programmeYear;
        const visibleDate        = dayjs(startDate).subtract(10, 'day').format('dddd, Do MMMM');
        const oneWeekBeforeStart = dayjs(startDate).subtract(7, 'day');

        renderWeeklyResourceHeader();
        if (homePageModuleVisible) {
            renderWeeklyResourceContent(selectedYear, weekNumber);
        }
        updateRedirectUrl(selectedYear, weekNumber);
        updateNextButtonState();

        const alertWarning     = $('#weekly-resource-visibility-warning');
        const alertWarningText = `This week is not yet visible to students. It will be visible after 5pm on ${visibleDate}`;

        if (studentProgrammeYear === null && startDate.isAfter(maxDate)) {
            if (alertWarning.length) {
                alertWarning.text(alertWarningText).show();
            } else {
                $('.panel-heading').after(`<div id="weekly-resource-visibility-warning" class="alert alert-warning">${alertWarningText}</div>`);
            }
        } else {
            alertWarning.hide();
        }

        var previousButtonDisabled = oneWeekBeforeStart.isBefore(startOfYear);

        $('#weekly-previous-button').prop('disabled', previousButtonDisabled);
    }

    /**
     * Check if the next button should be disabled
     *
     * @return void
     */
    function updateNextButtonState() {
        const oneWeekFromStart = dayjs(startDate).add(7, 'day');
        const isAfterMaxDate   = studentProgrammeYear !== null && oneWeekFromStart.isAfter(maxDate);
        const isAfterEndOfYear = studentProgrammeYear === null && oneWeekFromStart.isAfter(endOfYear);

        const nextButtonDisabled = isAfterMaxDate || isAfterEndOfYear;
        $('#weekly-next-button').prop('disabled', nextButtonDisabled);
    }

    /**
     * Save completion status of resources for a student
     *
     * @return void
     */
    function saveResourceCompletion() {
        var resourceId = $(this).data('resource-id');
        var checked = $(this).data('checked');
        var currentIconTitle = $(this).attr('title');
        var currentIconClass = checked === 1 ? checkedIconClass : uncheckedIconClass;

        // Toggle icon class between checked and unchecked
        var completed = checked === 1 ? 0 : 1;
        var updatedIconClass = completed === 1 ? checkedIconClass : uncheckedIconClass;
        var updatedIconTitle = currentIconTitle.replace(checked === 1 ? 'Complete' : 'Not Complete', checked === 1 ? 'Not Complete' : 'Complete');

        // AJAX request to save completion status

        $.ajax({
            type: 'post',
            url: 'weeklyresources/ajax_saveCompletedResource',
            data: {
                resourceid: resourceId,
                completed: completed,
                myvle_csrf_test_name: csrfToken,
            },
            success: function (response) {
                var errorContainer = $('#errorcontainer-' + resourceId);
                if (response.saved === undefined) {
                    if (errorContainer.length === 0) {
                        errorContainer = $('<span id="errorcontainer-' + resourceId + '" class="errorcontainer"></span>');
                        $(this).closest('.fa-stack').after(errorContainer);
                    }
                    errorContainer.html('<span class="error-message label label-danger">Error saving resource completion</span>');
                } else {
                    // Update icon only if response.saved is valid
                    errorContainer.empty();
                    $(this)
                        .removeClass(currentIconClass)
                        .addClass(updatedIconClass)
                        .attr('title', updatedIconTitle)
                        .data('checked', completed);
                }
            }.bind(this),
            error: function (xhr, status, error) {
                var errorContainer = $('#errorcontainer-' + resourceId);
                if (errorContainer.length === 0) {
                    errorContainer = $('<span id="errorcontainer-' + resourceId + '" class="errorcontainer"></span>');
                    $(this).closest('.fa-stack').after(errorContainer);
                }
                errorContainer.html('<span class="error-message label label-danger">Error saving resource completion: ' + error + '</span>');
            }.bind(this),
        });
    }

    /**
     * Update the redirect URL with the selected year and week number
     *
     * @param  integer year
     * @param  integer weekNumber
     * @return void
     */
    function updateRedirectUrl(year, weekNumber) {
        const updatedUrl = baseUrl + year + '/' + weekNumber;
        $('#weeklyresourceslink').attr('href', updatedUrl);
    }

    /**
     * Retrieve the year or week from the current URL based on the specified type
     *
     * @param  string type
     * @return string
     */
    function getYearOrWeekFromUrl(type) {
        const currentUrl = window.location.href;
        const urlParts = currentUrl.split('/');

        if (type === 'year') {
            return urlParts[urlParts.length - 2];
        }

        if (type === 'week') {
            return urlParts[urlParts.length - 1];
        }
    }

    /**
     * Redirect the user to a specific URL based on the given year and week number
     *
     * @param  string year
     * @param  string weekNumber
     * @return void
     */
    function redirectToUrl(year, weekNumber) {
        const adminBaseUrl = $('#resourcedatepicker').data('site-url');
        const redirectUrl = adminBaseUrl + year + '/' + weekNumber;
        window.location.assign(redirectUrl);
    }

    $('#resourcedatepicker').on('change', function () {
        const year = getYearOrWeekFromUrl('year');
        redirectToUrl(year, weekNumber);
    });

    $('#adminweeklyyearselect').on('change', function () {
        weekNumber = getYearOrWeekFromUrl('week');
        const year = $(this).val();
        redirectToUrl(year, weekNumber);
    });
});

/**
 * Toggle resources
 *
 * @return void
 */
export function toggleResourceVisibility(event) {
    event.preventDefault();

    var sectionId = $(this).attr('id').replace('-number-link', '');
    var resourceListItems = $('#' + sectionId + ' li.resource-item');

    resourceListItems.each(function (index) {
        if ($(this).hasClass('hide-resource')) {
            $(this).removeClass('hide-resource');
        } else if (index >= numResourcesToDisplay) {
            $(this).addClass('hide-resource');
        }
    });

    // Calculate the number of hidden resources and update text
    var hiddenResourceCount = $('#' + sectionId + ' li.hide-resource').length;
    $(this).html(hiddenResourceCount > 0 ? '<i class="' + FontAwesome.prefix('solid', 'arrow-turn-up') + ' fa-rotate-90"></i> Show ' + hiddenResourceCount + ' More' : '<i class="' + FontAwesome.prefix('solid', 'arrow-turn-down') + ' fa-rotate-90"></i> Show Less');
}
